import React,{ useRef } from 'react';
import axios from 'axios'
import { Tooltip,Popover,Result,Table,Popconfirm,Input, Button,Collapse,Card,Avatar,Modal,Form,DatePicker,Select,Space,Typography,Divider,InputNumber,message,Spin } from 'antd';
import Highlighter from 'react-highlight-words';
import Icon, { PrinterOutlined, MinusOutlined, CloseCircleFilled, CheckCircleOutlined, UserOutlined } from '@ant-design/icons';
import { DeleteOutlined,SearchOutlined,CameraOutlined,PlusOutlined,EditOutlined,PlusSquareFilled,SaveOutlined,LoadingOutlined } from '@ant-design/icons';
import QrReader from 'react-qr-reader'
import uuid from 'react-uuid'
import PhoneInput from 'react-phone-number-input'
import moment from 'moment';
import PrintTemplate from 'react-print';
import ReactToPrint from 'react-to-print';
import {
  Col,
  Row,
} from 'reactstrap';
import CurrencyFormat from 'react-currency-format';
import * as serverconfig from '../serverconn'
import * as reactstrp from 'reactstrap';
import { ToWords } from 'to-words';

var CryptoJS = require("crypto-js");

const { Panel } = Collapse;
const FormItem=Form.Item;
const { Option } = Select;
const dateFormat = 'DD/MM/YYYY';
const { Title } = Typography;
const { TextArea } = Input;
const antIcon = <LoadingOutlined style={{ fontSize: 60 }} spin />;

const toWords = new ToWords();

message.config({
  top: 200,
  duration: 2,
  maxCount: 3,
  rtl: true,
});


var sacco= ''
var username=''
var token= ''

class CumDividenttoSavingsTransferView extends React.Component {

  state = {
    date:moment().format(dateFormat).toString(),
    accountfrom:'',
    accountfromobject:{},
    accountto:'',
    accounttoobject:{},
    members:[],
    datarequested:true,
    datasubmittedsuccessfully:false,
    transaction_details:'',
    companyprofile:{}
  }

  callback(key) {
    console.log(key);
  }

  componentDidMount(){
    if(localStorage.getItem("sacco")){
       sacco= CryptoJS.AES.decrypt(localStorage.getItem("sacco") , 'my-secret-key@12345').toString(CryptoJS.enc.Utf8)
       username= CryptoJS.AES.decrypt(localStorage.getItem("username") , 'my-secret-key@123').toString(CryptoJS.enc.Utf8)
    
    }else{
       sacco= ''
       username=''
    }
    
    if(localStorage.getItem("token")){
       token= localStorage.getItem("token")
    }else{
       token= ''
    }

    axios.defaults.headers={
      "Content-Type":"application/json",
      Authorization:`Token ${token}`
    }

    axios.get(`${serverconfig.backendserverurl}/api/saccos/${sacco}`)
    .then(res => {  
        this.setState({
          companyprofile: res.data
        })

    })

    axios.get(serverconfig.backendserverurl+`/api/members/?sacco=${sacco}`)
    .then(res => {
        this.setState({
          members:res.data
        })
        //data
        this.setState({datarequested:false})

    })

  }



  //ccalculate txn amount
  calculateCumulativeAmount=()=>{
    var total=0

    this.state.members.map((item)=>{
      total+=Number(item.accumulated_dividendsbalance) 

    })

    return total;
  }

  
  ////////////////////////////////////
  // PRODUCT SEARCH SELECT METHODS
   onBlur=()=> {
    console.log('blur');
  }
  
   onFocus=()=>{
    console.log('focus');
  }
  
  onSearch=(val)=> {
    console.log('search:', val);
  }




  //submit the deposit now
  handleFormSubmit=(event) =>{

    if (this.state.transaction_details===''){
      message.error("Transaction details missing")
    }else if(this.calculateCumulativeAmount()<=0){
      message.error("No amount to tranfer")
    }
    
    
    else{
      this.setState({datarequested:true})
      console.log(username)
  
      let form_data = new FormData();
      form_data.append('date',moment().format(dateFormat).toString());
      form_data.append('transaction_details', this.state.transaction_details);
      form_data.append('sacco', sacco);
      form_data.append('username', username);
  
      axios.post(serverconfig.backendserverurl+'/customqueries/cumulativesividendstosharetransfer', form_data, {
        headers: {
          'content-type': 'multipart/form-data'
        }
        })
      .then(res => {
        this.setState({datarequested:false})
        message.info(res.data.message)
        if (res.data.message==="success"){
          this.setState({datasubmittedsuccessfully:true})
        }
        
      })
      .catch(error => console.log(error))
    }
    
  }


  ////////////////////////////////////////////
  // RENDERING METHOD HERE
  render() {

    if(this.state.datarequested===true){
      return(
        <div style={{display: 'flex',  justifyContent:'center', alignItems:'center' }}>
        <Spin indicator={antIcon} />
        </div>
      )

    }else{
      if(this.state.datasubmittedsuccessfully===true){
        return(
          <div>

            <Row >
                  <Col xs="12" sm="6" lg="6">
                    <Card>
                      <Result
                      status="success"
                      title="Successfully transfer "
                      subTitle="Successfull cumulative dividends transfer to savings"
                      extra={[
                        <Button  type='primary' onClick={()=>{window.location.reload(false)}}>Finish</Button>,
                      ]}
                      />

                  </Card>
                  </Col>
            </Row>

          </div>

        )

      }else{
        return(
          <div>
            <div>
  
                <Card>
              <h4 style={{fontStyle:'oblique',fontWeight:'bolder'}}>Cumulative dividends to savings Transfer Form (All members)</h4>
              <Form
                onFinish={(event) => this.handleFormSubmit(event)}
              >

              <h3>Total Cumulative dividends balance :<CurrencyFormat value={this.calculateCumulativeAmount()} displayType={'text'} thousandSeparator={true}  /> </h3>

              <FormItem label={<h4 style={{fontWeight:'bold'}}>Transaction details:</h4>} >
           
              <TextArea
                    placeholder="Details."
                    autoSize={{ minRows: 2, maxRows: 6 }}
                    value={this.state.transaction_details} 
                    onChange={(val)=>{this.setState({transaction_details:val.target.value})}}
                        />
             
              </FormItem>
            
              <FormItem>
                <Button  type="primary" htmlType="submit">Transfer</Button>
              </FormItem>
              </Form>

              </Card>
           
            </div>
  

       </div>              
                      
        )
      }

    
    }
   
  }
}

export default CumDividenttoSavingsTransferView; 
